<template>
  <operation-button
    class="create-restriction-button"
    variant="primary"
    prepend-icon-src="plus"
    :operation="operation"
    :icon="$vuetify.display.smAndDown"
  >
    <template v-if="!$vuetify.display.smAndDown"> Создать ограничение </template>
  </operation-button>
</template>

<script setup lang="ts">
import OperationButton from '@/core/components/buttons/OperationButton.vue';
import { OperationStatus } from '@/graphql/generated';

defineProps<{
  operation?: OperationStatus | null | undefined;
}>();
</script>

<style scoped lang="scss">
.create-restriction-button {
  @include sm-and-down {
    position: fixed;
    right: $gap-4;
    bottom: $gap-4;
    z-index: $z-index-3;
  }
}
</style>
